import { Mods, mods } from '@approvalmax/theme';
import { font, LoadingBar, TextButton } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const Root = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 0;
`;

export const Request = styled.div`
    overflow: auto;
    display: flex;
    flex-flow: column;
`;

export const Toolbar = styled.div`
    flex: none;
    padding: 25px 60px 30px 60px;
    border-bottom: 1px solid #cacccd;
    position: relative;
`;

export const ToolbarHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const ToolbarHeaderText = styled.div`
    text-transform: uppercase;
    ${font(20, '#333333', 'standard')}
`;

export const StyledLoadingBar = styled(LoadingBar)<StyledMods<Mods<'hide'>>>`
    bottom: 0;
    left: 0;
    width: 100%;
    position: absolute;

    ${mods.hide.true`
        visibility: hidden;
    `}
`;

export const Subheader = styled.div`
    padding: 25px 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SubheaderButtonsWrapper = styled.div`
    display: flex;
    gap: 4px;
`;

export const SubheaderButton = styled(TextButton)`
    padding: 0 5px;
`;

export const ToolbarHeaderTextContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 8px;
`;

export const BatchPaymentBills = styled.span`
    text-transform: uppercase;
    ${font(16, '#000', 'semibold')}
`;

export const LegendContainer = styled.div`
    margin: 0 60px 40px;
`;
